import { render } from "./TopEventsPage.vue?vue&type=template&id=7ff9c343"
import script from "./TopEventsPage.vue?vue&type=script&lang=js"
export * from "./TopEventsPage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TopEventsPage.vue?vue&type=style&index=0&id=7ff9c343&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__